import React from 'react';
import { Funnel } from '@ant-design/plots';

interface FunnelChartProps {
    statistics: {
        totalNominees: number;
        managerApproved: number;
        firstLevelApproved: number;
        secondLevelApproved: number;
        winners: number;
    };
}

const FunnelChart: React.FC<FunnelChartProps> = ({ statistics }) => {
    const data = [
        { stage: 'Total Nominations', number: statistics.totalNominees },
        { stage: 'Manager Approved Nominations', number: statistics.managerApproved },
        { stage: 'Level 1 Approved Nominations', number: statistics.firstLevelApproved },
        { stage: 'Level 2 Approved Nominations', number: statistics.secondLevelApproved },
        { stage: 'Winners', number: statistics.winners },
    ];

    const config = {
        data: data,
        xField: 'stage',
        yField: 'number',
        isTransposed: false,
        label: [
            {
                text: (d: any) => d.number,
                position: 'inside',
                fontSize: 16,
            },
            {
                render: (text: any, _: any, i: number) => {
                    if (i)
                        return (
                            <div
                                style={{
                                    height: 30,
                                    width: 1,
                                    background: '#aaa',
                                    marginTop: -30,
                                }}
                            ></div>
                        );
                    return null;
                },
                position: 'top-left',
            },
            {
                text: (d: any, i: number, data: any[]) => {
                    if (i) return ((d.number / data[i - 1].number) * 100).toFixed(2) + '%';
                    return '';
                },
                position: 'top-left',
                textAlign: 'middle',
                textBaseline: 'bottom',
                dy: -30,
            },
        ],
    };

    return <Funnel {...config} />;
};

export default FunnelChart;
